import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../TheCrypt";
import {gsap} from "gsap";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {ScatterCounter} from "../view/ScatterCounter";

export class TheCryptRoundEndPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return !TheCryptHelper.isRespin(TheCrypt.model.nextMode);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(()=>{
            if(!TheCrypt.model.freespinTriggeredThisSpin){
                ScatterCounter.reset();
            }
            TheCrypt.reelAnticipation.reset();
        });

        tl.add(() => controller.setSkipCallback());
        tl.to(this, {duration: 0.01});
    }
}